import React, { useState } from 'react';
import { testimonials } from '../data';
import { ReviewCard } from '../components/ui/Cards';
import './Testimonials.css';

const extra = [
  { id: 7, name: 'Sophie B.', country: 'Belgium', flag: '🇧🇪', rating: 5, text: 'Absolutely incredible day at the Ouzoud Waterfalls. The monkeys were hilarious and the waterfall is just stunning. Perfectly organised from start to finish.', tour: 'Ouzoud Waterfalls Day Trip' },
  { id: 8, name: 'Carlos M.', country: 'Spain', flag: '🇪🇸', rating: 5, text: 'The sidecar tour was such a unique way to see Marrakech. Our driver was fantastic — funny, knowledgeable, and took us to all the best spots. 10/10!', tour: 'Sidecar Tour of Marrakech' },
  { id: 9, name: 'Anna K.', country: 'Netherlands', flag: '🇳🇱', rating: 5, text: 'We did the Agafay desert buggy ride as a couple — best activity of our whole trip to Morocco. The landscape is just otherworldly. Book it!', tour: 'Buggy Ride in Agafay Desert' },
  { id: 10, name: 'Tom H.', country: 'Canada', flag: '🇨🇦', rating: 5, text: 'The medina food tour was a revelation. We ate at places we never would have found on our own. The harira soup, the mechoui lamb... I dream about it still.', tour: 'Marrakech Food Tour' },
  { id: 11, name: 'Claire P.', country: 'Ireland', flag: '🇮🇪', rating: 5, text: 'Horseback riding at Lake Takerkoust with the Atlas Mountains in the background — what a view! Patient horses, amazing guide. Perfect afternoon.', tour: 'Horseback Riding at Lake Takerkoust' },
  { id: 12, name: 'Henrik L.', country: 'Sweden', flag: '🇸🇪', rating: 5, text: 'Everything about this company screams professionalism and genuine passion. Picked up on time, amazing guide, exactly as described. They will be my go-to for any Morocco visit.', tour: 'Aït Ben Haddou & Kasbah Telouet' },
];

const allReviews = [...testimonials, ...extra];

export default function Testimonials() {
  const [filter, setFilter] = useState('all');

  const filtered = filter === 'all' ? allReviews : allReviews.filter(r =>
    r.tour.toLowerCase().includes(filter.toLowerCase())
  );

  const avgRating = (allReviews.reduce((s, r) => s + r.rating, 0) / allReviews.length).toFixed(1);

  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="section-tag">Guest Reviews</div>
          <h1>What Our Travelers Say</h1>
          <p>{avgRating} average rating · {allReviews.length}+ verified reviews</p>
        </div>
      </div>

      <section className="section section-white">
        <div className="container">

          <div className="reviews-summary">
            <div className="reviews-summary__score">
              <div className="reviews-summary__num">{avgRating}</div>
              <div className="stars" style={{ fontSize: 20 }}>★★★★★</div>
              <div className="reviews-summary__count">{allReviews.length}+ reviews</div>
            </div>
            <div className="reviews-summary__bars">
              {[5, 4, 3].map(star => {
                const count = allReviews.filter(r => r.rating === star).length;
                const pct = Math.round((count / allReviews.length) * 100);
                return (
                  <div key={star} className="rating-bar">
                    <span className="rating-bar__label">{star} stars</span>
                    <div className="rating-bar__track">
                      <div className="rating-bar__fill" style={{ width: `${pct}%` }} />
                    </div>
                    <span className="rating-bar__pct">{pct}%</span>
                  </div>
                );
              })}
            </div>
            <div className="reviews-summary__platforms">
              <div className="platform-badge">🟢 TripAdvisor · 4.9</div>
              <div className="platform-badge">⭐ Google · 4.8</div>
              <div className="platform-badge">✓ Verified Bookings</div>
            </div>
          </div>

          <div className="reviews-filter">
            {['all', 'Atlas', 'Agafay', 'Balloon', 'Cooking', 'Medina'].map(f => (
              <button key={f} className={`list-tab${filter === f ? ' active' : ''}`} onClick={() => setFilter(f)}>
                {f === 'all' ? 'All Reviews' : f}
              </button>
            ))}
          </div>

          <div className="grid-3">
            {filtered.map(r => <ReviewCard key={r.id} review={r} />)}
          </div>

          <div className="reviews-cta">
            <p>Visited with us? We'd love to hear about your experience.</p>
            <a href="https://www.tripadvisor.com/Attraction_Review-g293734-d33258631-Reviews-Marrakech_Best_Activities-Marrakech_Marrakech_Safi.html" target="_blank" rel="noreferrer" className="btn btn-ghost">
              Leave a Review on TripAdvisor →
            </a>
          </div>
        </div>
      </section>

      {/* Guest Photos */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Real Moments</span>
            <h2 className="section-title">Captured by Our <em>Guests</em></h2>
          </div>
          <div className="guest-photos-grid">
            <div className="guest-photo guest-photo--large">
              <img src="https://www.image2url.com/r2/default/images/1777233533626-69a376fc-6d9e-4938-ad5c-cb0b67d0aae3.jpg" alt="Guest photo Morocco" loading="lazy" />
              <div className="guest-photo__overlay">
                <span className="guest-photo__tag">📍 Morocco</span>
              </div>
            </div>
            <div className="guest-photo">
              <img src="https://www.image2url.com/r2/default/images/1777233884431-7a4fe34a-2f1f-45b8-a275-06049b7b185f.jpg" alt="Guest photo Morocco" loading="lazy" />
              <div className="guest-photo__overlay">
                <span className="guest-photo__tag">📍 Marrakech</span>
              </div>
            </div>
            <div className="guest-photo">
              <img src="https://www.image2url.com/r2/default/images/1777233911836-5a645660-bebe-4b9c-a299-c002bcb036af.jpg" alt="Guest photo Morocco" loading="lazy" />
              <div className="guest-photo__overlay">
                <span className="guest-photo__tag">📍 Atlas Mountains</span>
              </div>
            </div>
            <div className="guest-photo guest-photo--wide">
              <img src="https://www.image2url.com/r2/default/images/1777233930243-aed128cc-45a6-4587-9601-1b8562c78d71.jpg" alt="Guest photo Morocco" loading="lazy" />
              <div className="guest-photo__overlay">
                <span className="guest-photo__tag">📍 Agafay Desert</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
